/// <reference path="../../types.d.ts" />
import { connect } from 'react-redux';
import { buildDispatchable } from '../../actions/_action-utilities';
import history from '../../history';
import { Features } from './features';
import { updateFeatures } from '../../actions/organization';
import { formErrors } from '../../stubs/form-errors';
export const mapStateToProps = function(state) {
    const { organization } = state;
    return {
        features: organization.features ?? [],
        errors: formErrors.noErrors
    };
};
export const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        handleSave: (item)=>{
            runDispatchable(()=>{
                return dispatch(updateFeatures(item));
            });
        },
        handleCancel: ()=>{
            runDispatchable(()=>{
                history.goBack();
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Features);
